/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { isIOS } from "react-device-detect";

export interface IClientsProps {
    clientSectionId?: string;
    clientLabel?: string;
    clientDescription?: string;
    clientData?: string[];
}

export const Clients = ({
    clientSectionId,
    clientLabel,
    clientDescription,
    clientData
}: IClientsProps) => {
    const _renderLabel = () => {
        return (
            <header className="section-header">
                <h2>{clientLabel}</h2>
                {clientDescription && <p>{clientDescription}</p>}
            </header>
        );
    };

    const _renderClientImages = () => {
        const _comp: any = [];
        if (clientData) {
            clientData?.forEach((client, index) => {
                if (client) {
                    _comp.push(
                        <div
                            key={`landing-page-client-${index}`}
                            className="swiper-slide"
                        >
                            <img src={client} className="img-fluid" alt="" />
                        </div>
                    );
                }
            });
        }
        return _comp;
    };
    let _aos_props: any = {};
    if (!isIOS) {
        _aos_props = {
            "data-aos": "fade-up"
        };
    }
    return (
        <section id={clientSectionId} className="clients">
            <div className="container" {..._aos_props}>
                {_renderLabel()}

                <div className="clients-slider swiper">
                    <div className="swiper-wrapper align-items-center">
                        {_renderClientImages()}
                    </div>
                    {clientData?.length && (
                        <div className="swiper-pagination" />
                    )}
                </div>
            </div>
        </section>
    );
};

Clients.defaultProps = {
    clientLabel: "Our Clients",
    clientSectionId: "clients"
};
